import $ from 'jquery'
import Base from 'luminate/src/modules/base'

const $window = $(window)

export default Base.extend({
	directive: 'scroll-marker',

	modules: {

		items: Base.extend({
			directive: 'scroll-marker-item',

			defaults: {
				target: '',
				classSelected: 'is-selected'
			},

			events: {

				init: function()
				{
					const target = this.$settings.target

					this.target = $(`[scroll-marker-rel="${target}"]`)
				}
			},

			methods: {

				observeDelta: function()
				{
					return this.target.offset().top - $window.scrollTop()
				},

				toggle: function(select = null)
				{
					select = (typeof select === 'boolean' ? select : !this.target.hasClass(this.$settings.classSelected))

					this.target.add(this.$element).toggleClass(this.$settings.classSelected, select)
				},

				select: function()
				{
					this.toggle(true)
				},

				unselect: function()
				{
					this.toggle(false)
				}
			}
		})
	},

	events: {

		init: function()
		{
			$window.on('resize scroll', e =>
			{
				let closestItem = null
				let closestDistance = null

				for(let item of this.$owns.items)
				{
					item.unselect()

					if(!closestItem)
					{
						closestItem = item
						closestDistance = Math.abs(item.observeDelta())
					}
					else
					{
						let distance = Math.abs(item.observeDelta())

						if(distance < closestDistance)
						{
							closestItem = item
							closestDistance = distance
						}
					}
				}

				if(closestItem)
				{
					closestItem.select()
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/legacy/modules/scroll-marker.js